export const TYPE_COLOR_POLICIES_MAP: Record<string, string> = {
  restriction: '#e57373',
  requirement: '#64b5f6',
  guideline: '#81c784',
  warning: '#ffb74d',
};

export const TYPE_FRIENDLY_NAME_POLICIES_MAP: Record<string, string> = {
  restriction: 'Restriction',
  requirement: 'Requirement',
  guideline: 'Guideline',
  warning: 'Warning',
};

export const POLICY_TYPE_OPTIONS = Object.keys(TYPE_COLOR_POLICIES_MAP);

export const POLICY_CATEGORIES = [
  'Membership',
  'General',
  'Troubleshooting',
  'Escalation',
] as const;

export const POLICY_CATEGORY_ESCALATION = 'Escalation';

/** Categories available in the standard "Add Policy" form (excludes Escalation). */
export const POLICY_CATEGORIES_STANDARD = POLICY_CATEGORIES.filter(
  (c) => c !== POLICY_CATEGORY_ESCALATION,
);
